import SvgIcon from './SvgIcon';

export default function NewOverlayIcon(props) {
  return (
    <SvgIcon
      {...props}
      width="21px"
      height="18px"
      viewBox="0 0 21 18"
      version="1.1">
      <g
        id="Page-1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd">
        <g
          id="Build---Preview"
          transform="translate(-613.000000, -516.000000)"
          fillRule="nonzero">
          <g id="NewOverlayIcon" transform="translate(613.000000, 516.000000)">
            <path
              d="M16.1538462,3.27272727 C16.5999223,3.27272727 16.9615385,2.9064148 16.9615385,2.45454545 L16.9615385,1.63636364 C16.9615385,0.732624955 16.2383061,0 15.3461538,0 L1.61538462,0 C0.723232327,0 0,0.732624955 0,1.63636364 L0,12.2727273 C0,13.176466 0.723232327,13.9090909 1.61538462,13.9090909 L2.42307692,13.9090909 C2.86915307,13.9090909 3.23076923,13.5427784 3.23076923,13.0909091 L3.23076923,5.72727273 C3.23076923,4.3716647 4.31561772,3.27272727 5.65384615,3.27272727 L16.1538462,3.27272727 Z"
              id="Path"
              fill="#BCCCE4"
            />
            <path
              d="M19.3846154,4.09090909 L5.65384615,4.09090909 C4.76169387,4.09090909 4.03846154,4.82353405 4.03846154,5.72727273 L4.03846154,16.3636364 C4.03846154,17.267375 4.76169387,18 5.65384615,18 L19.3846154,18 C20.2767677,18 21,17.267375 21,16.3636364 L21,5.72727273 C21,4.82353405 20.2767677,4.09090909 19.3846154,4.09090909 Z"
              id="Path"
              fill="#E4EBF4"
            />
          </g>
        </g>
      </g>
    </SvgIcon>
  );
}
